import zIndex from "@mui/material/styles/zIndex";
import theme from "../../../../Constants/theme";

export const chatWindowContainer = {
  display: "flex",
  flexDirection: "column",
  height: { xs: "98vh", md: "650px" },
  minHeight: "640px",
  maxHeight: { xs: "98vh", md: "640px" },
  backgroundColor: theme.main.applicationBackground,
  color: theme.textColors.dark.primary,
  overflowX: "hidden",
  borderRadius: theme.borderRadius.md,
};

export const selectedParameters = {
  padding: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-start",
  borderRadius: chatWindowContainer.borderRadius,
  height: "100%",
  transition: "all 0.2s ease",
  zIndex: 2,
};

export const parameterChip = {
  marginBottom: "5px",
  padding: "6px",
  borderRadius: chatWindowContainer.borderRadius,
  backgroundColor: theme.main.chatwindow,
  border: `1px solid ${theme.border.divider}`,
};

export const questionButton = {
  marginTop: "10px",
  marginBottom: "10px",
  display: "flex",
  flexDirection: { xs: "column", md: "row" },
  justifyContent: "space-between",
  gap: "10px",
  alignItems: "center",
  width: "96.5%",
  alignSelf: "center",
};

export const questionButtonTypography = {
  color: "#fff",
  backgroundColor: theme.backgroundColors.dark.primary,
  cursor: "pointer",
  padding: "10px 10px",
  borderRadius: "10px",
  border: `1px solid ${theme.border.light}`,
  height: "auto",
};

export const applicationCardContainer = {
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  alignItems: "flex-start",
  backgroundColor: theme.main.chatwindow,
  padding: "16px",
  borderRadius: chatWindowContainer.borderRadius,
  color: theme.textColors.dark.primary,
  width: "250px",
  height: "240px",
  border: questionButtonTypography.border,
};

export const chatHeader = {
  position: "absolute", // Pin the box to the top
  top: 0,
  left: 0,
  width: "100%",
  display: "flex",
  justifyContent: "center",
  backgroundColor: theme.main.chatwindow,
  zIndex: 1,
  color: "white",
  py: 1,
  borderBottom: `1px solid ${theme.border.divider}`,
};

export const mainChatWindow = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  backgroundColor: theme.main.chatwindow,
  position: "relative", // Added for positioning
  pt: 6, // Padding top
  overflowY: "auto", // Enable vertical scrolling
};
